// libs
import { createContext, useContext } from 'react';

// types
import { ProviderContentContextProps } from '../types';

export const ProviderContentContext = createContext<ProviderContentContextProps | null>(null);

export const useProviderContent = () => {
  const value = useContext(ProviderContentContext);

  if (!value) {
    throw new Error('[ProviderContentContext] Not initialised');
  }

  return value;
};
